<svelte:options runes={false} />

<script>
  import OperatorAccountSettings from '../components/OperatorAccountSettings.svelte';
  import SectionHeading from '../components/SectionHeading.svelte';

  export let operatorMembership;
  export let selectedThemeId;
  export let themeSavePending;
  export let accountDefaultCurrency;
  export let accountCurrencySavePending;
  export let onSelectTheme;
  export let onSelectDefaultCurrency;
  export let onBack;

  $: canManage = ['owner', 'admin'].includes(operatorMembership?.role);
</script>

<section class="panel operator-settings-panel">
  <SectionHeading eyebrow="Operator" title="Account settings">
    <svelte:fragment slot="trailing">
      <button type="button" on:click={onBack}>‹ Back to desk</button>
    </svelte:fragment>
  </SectionHeading>

  <OperatorAccountSettings
    {selectedThemeId}
    {themeSavePending}
    {canManage}
    {onSelectTheme}
    {accountDefaultCurrency}
    {accountCurrencySavePending}
    {onSelectDefaultCurrency}
  />
</section>
